import React, {Fragment} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification,
    Spin, Steps, Divider, DatePicker, Switch
} from "antd";

import {
    DownOutlined,
    DownloadOutlined,
    DeleteOutlined,
    PlusOutlined,
    EuroCircleOutlined,
    LinkOutlined,
    MinusOutlined
} from '@ant-design/icons';

import ApiService from "../../../services/ApiService"

import IntlMessage from "../../../components/util-components/IntlMessage";

import moment from 'moment'
import PermissionAlert from "../../../components/permissions/PermissionAlert";
import PromessesListForm from '../../../components/custom-fields/PromessesList';
import { getDevise, getDeviseSymbol } from '../../../components/permissions/functions';
import { connect } from 'react-redux';

import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


class ModalChangeDettes extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initstate = {
        visible: false,
        loading: false,
        info: null,
        id: null,
        contactId: null,
        defaultData:{},
        errorPromesses: false,
    };

    state = this.initstate

    async show(data) {
        console.log("PAYEMENT CHANGE DETTES ", data)

        let defaultData={...data}
        defaultData.montant=data.amount/100

        this.setState({visible: true, id: data.id,contactId:data.contact.id, defaultData: defaultData})
    }

    close() {
        this.setState(this.initstate)
    }

    async onFinish(data) {
        console.log(data)

        var res = await ApiService.post("/paiements/change/dettes/" + this.state.id, {dettes: data.dettes})
        console.log(res)

        if (res.success) {
            notification.success({
                message: t`Modification réussie`
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish()
            }
        } else {
            notification.error({
                message: t`Erreur lors de la modification`
            })
        }
    }


    render() {


        return (

            <Fragment>
                <Modal width={"100%"} style={{minHeight: 500}}
                       title={t`Attribuer des promesses de dons`}
                       open={this.state.visible}
                       destroyOnClose
                       closable
                       footer={null}
                       onCancel={() => this.close()}>
                    <PermissionAlert permissions={["paiement.edit"]}>
                        <Form
                            initialValues={this.state.defaultData}
                            onFinish={(data) => this.onFinish(data)}
                        >

                            <Form.Item noStyle shouldUpdate>
                                {()=>{
                                    const devise=this.props.org.cerfasInfos.find(i=>i.id===(this.state.defaultData?.assoc || "MAIN"))?.devise || getDevise()
                                    return(
                                        <Form.Item
                                            label={t`Montant`}
                                            name="montant"
                                        >
                                            <InputNumber
                                                decimalSeparator={','} min={1}
                                                step={0.5}
                                                addonAfter={getDeviseSymbol(devise)}
                                                readOnly
                                                disabled
                                            />
                                        </Form.Item>
                                    )
                                }}
                            </Form.Item>

                            <PromessesListForm
                                forceOpen
                                contactId={this.state.contactId}
                                assoc={this.state.defaultData.assoc}
                                errored={this.state.errorPromesses}
                                onErrored={(bool)=>this.setState({errorPromesses:bool})}
                            />

                            <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={this.state.loading}
                                    disabled={this.state.loading || this.state.errorPromesses}>
                                    <Trans>Valider</Trans>
                                </Button>
                            </Form.Item>
                        </Form>
                    </PermissionAlert>
                </Modal>
            </Fragment>


        )
    }
}

const mapStateToProps = (state) => {
    return {
        org: state.auth.org
    }
}

export default connect(mapStateToProps)(ModalChangeDettes)
